import React from "react";
import "./App.css";
import { FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";

function App() {
  return (
    <div className="page">
      <div className="container">
        <header className="header">
          <h1 className="gradient-name"><strong>AISWARYA A S</strong></h1>
          <p className="subtitle">React Frontend Developer</p>
          <p className="email"><strong>Email:</strong> aiswaryasreekumaras@gmail.com</p>
        </header>

        <section className="section">
          <h2>About Me</h2>
          <p>
            I am a passionate React Frontend Developer focused on creating clean, user-friendly web interfaces.
            I enjoy building responsive applications with React.js and continuously learning modern JavaScript tools
            to improve my craft.
          </p>
        </section>

        <section className="section">
          <h2>Educational Qualifications</h2>
          <ul>
            <li><strong>Post Graduation:</strong> MA ECONOMICS – Karyavattom School of Distance Education (2024)</li>
            <li><strong>Graduation:</strong> BA ECONOMICS – VTMNSS College, Dhanuvachapuram (2021)</li>
          </ul>
        </section>

        <section className="section">
          <h2>Hobbies</h2>
          <ul>
            <li>Coding</li>
            <li>Reading</li>
          </ul>
        </section>

        <section className="section">
          <h2>Projects</h2>
          <ul>
            <li><strong>To-Do App:</strong> A task management app using React and LocalStorage.</li>
            <li><strong>Weather App:</strong> Fetches real-time weather from OpenWeather API.</li>
            <li><strong>Personal Webpage:</strong> This responsive portfolio made with React.js.</li>
          </ul>
        </section>

        <section className="section">
          <h2>Skills</h2>
          <ul className="skills-list">
            <li className="skill-pill">HTML5</li>
            <li className="skill-pill">CSS3</li>
            <li className="skill-pill">JavaScript (ES6+)</li>
            <li className="skill-pill">React.js</li>
            <li className="skill-pill">Git & GitHub</li>
            <li className="skill-pill">Responsive Design</li>
          </ul>
        </section>

        <section className="section">
          <h2>Find Me Online</h2>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/aiswarya-a-s-011a65287/" target="_blank" rel="noreferrer">
              <FaLinkedin /> LinkedIn
            </a>
            <a href="https://github.com/aiswaryasreekumarAS/my-react-app" target="_blank" rel="noreferrer">
              <FaGithub /> GitHub
            </a>
            <a href="https://www.instagram.com/__ishwarya_____/" target="_blank" rel="noreferrer">
              <FaInstagram /> Instagram
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
